let apiKey: string | null

export const setApiKey = (key: string): void => {
  apiKey = key
}

export const getApiKey = (): string | null => {
  return apiKey
}
